import { Hidden } from "@material-ui/core";
import React, {useEffect, useRef, useState} from "react";
import { useHistory, withRouter } from "react-router-dom";
import useConfig from "../../qnect-ui/qnect-config";
import { _getCountry, _getLang, _hideSpinner, _showSpinner, _showModal, _hideModal, _showError } from "../../../store/system/service";
import { _getInvoiceRaterDetails, _submitInvoice } from "../../../store/invoice/service";
import useCalculationStyles, { BackIcon, BackWrapper, Container, Title, TopWrapper } from "./calculation-style";
import {ReactComponent as ClaimAmountIcon} from "../../../assets/invoice/claim_amount_selected.svg";
import { connect } from "react-redux";
import QnectError from "../../qnect-ui/qnect-error";
import QnectTextField from "../../qnect-ui/qnect-text-field";
import FieldWrapper from "../../custom/field-wrapper";
import QnectCheckBox from "../../qnect-ui/qnect-check-box";
import QnectButton from "../../qnect-ui/qnect-button";
import UploadDocument from "../../upload-document/upload-document";
import {
    _formatDecimalAmount,
    _removeDecimalFormatting,
    _validateForm,
    _getCurrency,
    _formatAmount,
} from "../../../utils/utility";
import { Button, FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import { _getClaim } from "../../../store/claims/service";
import BalloonTip from "../../ui/balloon-tip/balloon-tip";
import SubmitInvoiceDialog from "./submit-invoice-dialog";

export const ClaimAmountCalculation = (props) => {
    const classes = useCalculationStyles(props);
    const history = useHistory();
    const cfg = useConfig(props.lang);
    const ref = useRef(null);
    const formId = 'byClaimAmount';
    const [errorMessage, setErrorMessage] = useState([]);
    const [providerInvoiceNo, setProviderInvoiceNo] = useState("");
    const [claimAmount, setClaimAmount] = useState("");
    const [isDesktop, setIsDesktop] = useState(false);
    const [isDiscount, setIsDiscount] = useState(false);
    const [discountPercentage, setDiscountPercentage] = useState("");
    const [discountAmount, setDiscountAmount] = useState("");
    const [selectedDiscountBasis, setSelectedDiscountBasis] = useState("");
    const [isQbeShare, setIsQbeShare] = useState(false);
    const [qbeShareRate, setQbeShareRate] = useState("");
    const [isDisbursement, setIsDisbursement] = useState(false);
    const [disbursements, setDisbursements] = useState([]);
    const [totalFee, setTotalFee] = useState('0.00');
    const currency = _getCurrency(props.country);
    const maxPercentLimit = 100;
    const [gst, setGST] = useState('');
    const [totalInvoiceAmount, setTotalInvoiceAmount] = useState('0.00');
    const [invoiceRateDetails, setInvoiceRateDetails] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [identifier, setIdentifier] = useState("") ;
    const [isSubmit, setIsSubmit] = useState(false);
    const [showSubmitDialog, setShowSubmitDialog] = useState(false);
    const [invoiceForm, setInvoiceForm] = useState(null);

    useEffect(() => {
        resetData();
        loadInvoiceRate();
    }, []);

    useEffect(() => {
        if (claimAmount) {
            calculateTotalFee();
        }
    }, [gst]);

    useEffect(() => {
        if (isSubmit) {
            submit();
            setIsSubmit(false);
        }
    },[isSubmit]);

    const loadInvoiceRate = () => {
        props.showSpinner();
        props.getInvoiceRaterDetails('BCA').then((response) => {
            setInvoiceRateDetails(response?.claimAmountRateList);
            props.hideSpinner();
        }, (error) => {
            console.log('loadInvoiceRate - error occurred', error);
            props.hideSpinner();
        })
    };

    const changeDesktop = (evt) => {
        setIsDesktop(evt);
    };

    const changeDiscount = (evt) => {
        setIsDiscount(evt);
        if (evt) {
            setSelectedDiscountBasis("discountPercentageRadio");
        } else {
            setDiscountAmount("");
            setDiscountPercentage("");
        }
    };

    const changeDiscountBasis = (value) => {
        setSelectedDiscountBasis(value);
        if (value === 'discountPercentageRadio') {
            setDiscountAmount("");
        } else {
            setDiscountPercentage("");
        }
    };

    const changeDisbursement = (evt) => {
        setIsDisbursement(evt);
        setDisbursements([]);
        if (evt) {
            handleAddRow();
        }
    };

    const handleUpdateDisbursementFields = (index, field, val) => {
        setErrorMessage([]);
        setDisbursements(prev => {
            const newState = prev.map((obj, i) => {
                if (i === index ) {
                    if (field === 'disbursementDesc') {
                        return {...obj, disbursementDesc: val};
                    } else if (field === 'disbursementAmt') {
                        return {...obj, disbursementAmt: val};
                    }
                }
                return obj;
            });
            return newState;
        });
    };

    const changeQbeShare = (evt) => {
        setIsQbeShare(evt);
    };

    const handleRemoveRow = (idx) => {
        setErrorMessage([]);

        const data = disbursements.filter((item, i) => i !== idx);
        const newArr = [];
        const item = {
            disbursementDesc: '',
            disbursementAmt: ''
        };
        setDisbursements(prev => {
            if (prev.length === 1) {
                return [...newArr, item];
            } else  {
                return data;
            }
        });
    };

    const handleAddRow = () => {
        setErrorMessage([]);
        if (disbursements.length >= 10) {
            setErrorMessage("Maximum number of rows reached for disbursements.");
            return;
        }
        const item = {
            disbursementDesc: '',
            disbursementAmt: ''
        };
        setDisbursements([...disbursements, item]);
    };

    const calculateTotalFee = () => {
        resetTotalFees();
        _validateForm(formId);

        const inputClaimAmount = parseFloat(_removeDecimalFormatting(claimAmount));
        let rateDetail = getRateDetail(inputClaimAmount);
        let calculatedInvoiceFee = 0;

        if (rateDetail == null) {
            return;
        } else {
            calculatedInvoiceFee = parseFloat(calculateInvoiceFee(rateDetail, inputClaimAmount, isDesktop)) || calculatedInvoiceFee.toFixed(2);
        }

        if (disbursements && disbursements.length > 0) {
            let totalDisbursement = 0;
            disbursements.forEach((item) => {
                totalDisbursement += parseFloat(_removeDecimalFormatting(item.disbursementAmt ? item.disbursementAmt : "0"))
            });
            calculatedInvoiceFee += totalDisbursement;
        }


        if (isDiscount) {
            if (discountPercentage) {
                let discountRate = (100 - parseFloat(discountPercentage)) / 100;
                calculatedInvoiceFee = parseFloat((parseFloat(calculatedInvoiceFee) * discountRate));
            } else if (discountAmount) {
                calculatedInvoiceFee -= parseFloat(_removeDecimalFormatting(discountAmount));
            }
        }

        if (isQbeShare && qbeShareRate) {
            let rate = parseFloat(qbeShareRate)/100;
            calculatedInvoiceFee *= rate;
        }

        setTotalFee(_formatAmount(calculatedInvoiceFee, true));

        if (props.country !== 'HKG' && gst) {
            calculatedInvoiceFee += parseFloat(_removeDecimalFormatting(gst));
        }

        setTotalInvoiceAmount(_formatAmount(calculatedInvoiceFee, true));
    };
    
    const submit = () => {
        if (_validateForm(formId) && _validateForm("uploadDocsForm") && errorMessage.length === 0) {

            let invoiceDetailsForm = {
                providerInvoiceNo: providerInvoiceNo,
                claimAmount: _formatAmount(claimAmount, false),
                isDesktop: isDesktop,
                discountPercentage: discountPercentage,
                discountAmount: _formatAmount(discountAmount, false),
                qbeShareRate: qbeShareRate,
                disbursements: unformatDisbursementAmount(),
                totalFee: _formatAmount(totalFee, false),
                gst: _formatAmount(gst, false),
                totalInvoiceAmount: _formatAmount(totalInvoiceAmount, false),
                type: cfg('invoice.calculations.byClaimAmount'),
                documentForm: {
                    identifier: identifier,
                    documents: attachments
                }
            };

            setShowSubmitDialog(true);
            setInvoiceForm(invoiceDetailsForm);
        }
    };

    const validateDiscountLimit = (val) => {
        const v = _removeDecimalFormatting(val);
        if (v > maxPercentLimit) {
            return;
        } else {
            setDiscountPercentage(val);
        }
    };

    const validateQbeShareLimit = (val) => {
        const v = _removeDecimalFormatting(val);
        if (v > maxPercentLimit) {
            return;
        } else {
            setQbeShareRate(val);
        }
    };

    const getRateDetail = (inputClaimAmount) => {
        let rateDetail = null;
        if (invoiceRateDetails.length > 0) {
            rateDetail = invoiceRateDetails.find(obj => {
                return (parseFloat(obj.minClaimAmount) <= inputClaimAmount && inputClaimAmount <= parseFloat(obj.maxClaimAmount))
            });
            if (rateDetail === null || rateDetail === undefined) {
                setErrorMessage("No rate configuration found.");
            }
        } else {
            setErrorMessage("No rate configuration found.");
        }
        return rateDetail;
    };

    const resetData = () => {
        setErrorMessage([]);
        setProviderInvoiceNo('');
        setClaimAmount('');
        setIsDesktop(false);
        setIsDiscount(false);
        setDiscountPercentage('');
        setDiscountAmount('');
        setSelectedDiscountBasis('');
        setIsQbeShare(false);
        setQbeShareRate('');
        setIsDisbursement(false);
        setDisbursements([]);
        setTotalFee('0.00');
        setTotalInvoiceAmount('0.00');
        setInvoiceRateDetails([]);
    };

    const resetTotalFees = () => {
        setErrorMessage([]);
        setTotalFee('0.00');
        setTotalInvoiceAmount('0.00');
    };

    const calculateInvoiceFee = (invoiceRateDetail, inputClaimAmount, isDesktop) => {
        const claimAmt = parseFloat(inputClaimAmount);
        const minClaimAmt = parseFloat(invoiceRateDetail.minClaimAmount);
        const maxClaimAmt = parseFloat(invoiceRateDetail.maxClaimAmount);
        const maxProportionateAmount = invoiceRateDetail.maxProportionateAmount ? parseFloat(invoiceRateDetail.maxProportionateAmount) : 0;
        const minProportionateAmount = invoiceRateDetail.minProportionateAmount ? parseFloat(invoiceRateDetail.minProportionateAmount) : 0;
        const additionalRate = invoiceRateDetail.additionalRate ? (parseFloat(invoiceRateDetail.additionalRate))/100 : 0;
        const additionalRateLimits = invoiceRateDetail.additionalRateLimits ? (parseFloat(invoiceRateDetail.additionalRateLimits))/100 : 0;
        const fixedRateAmount = invoiceRateDetail.fixedRateAmount ? parseFloat(invoiceRateDetail.fixedRateAmount) : 0;
        const minFixedAmount = invoiceRateDetail.minFixedAmount ? parseFloat(invoiceRateDetail.minFixedAmount) : 0;
        const desktopRate = parseFloat(invoiceRateDetail.desktopRate);
        const desktopFixedAmount = parseFloat(invoiceRateDetail.desktopFixedAmount);
        
        let x = 0;
        let y = 0;
        const z = minFixedAmount;

        if (invoiceRateDetail.additionalRateLimits) {
            x = ((claimAmt - minClaimAmt) / (maxClaimAmt - minClaimAmt) * 
            (maxProportionateAmount - minProportionateAmount) + minProportionateAmount) + 
            ((claimAmt - (minClaimAmt - 1)) * additionalRateLimits);

            y = (fixedRateAmount + ((claimAmt - (minClaimAmt - 1)) * additionalRateLimits));
        } else {
            x = ((claimAmt - minClaimAmt) / (maxClaimAmt - minClaimAmt) * 
            (maxProportionateAmount - minProportionateAmount) + minProportionateAmount) + 
            (claimAmt * additionalRate);
            y = (fixedRateAmount + (claimAmt * additionalRate));
        }
    
        // FORMULA 2 (NOT DESKTOP)
        let calculatedInvoiceFee = parseFloat(Math.max(x, y, z));
    
        if (isDesktop) {
            if (desktopRate) { // FORMULA 1
                const rate = ((100 - parseFloat(desktopRate))/100);
                calculatedInvoiceFee = (calculatedInvoiceFee * rate);
            } else if (desktopFixedAmount) { // FORMULA 3
                calculatedInvoiceFee = desktopFixedAmount;
            }
        }

        return calculatedInvoiceFee;
    };

    const unformatDisbursementAmount = () => {
        const array = [...disbursements];
        let unformattedArr = array.map(elem => (
            elem.disbursementAmt ? {...elem, disbursementAmt: _formatAmount(elem.disbursementAmt, false)} : elem
        ))

        return unformattedArr;
    };

    return (
        <>
        <Container>
            <div className={classes.box}>
                <TopWrapper>
                    <Hidden mdDown>
                        <BackWrapper onClick={() => history.push("/viewInvoice")}>
                            <BackIcon/>{cfg('backBtn.label')}
                        </BackWrapper>
                        <Title>{cfg('invoice.createInvoice')}</Title>
                    </Hidden>
                    
                </TopWrapper>
            </div>
            <div style={{overflowY: "auto !important"}}>
                <div className={classes.rectangle}>
                    <div style={{backgroundColor: '#F7F8F9'}}>
                        <ClaimAmountIcon className={classes.calculationMethodIcon}/>
                        <div className={classes.calculationMethodTitle}><h2>{cfg('invoice.calculations.byClaimAmount')}</h2></div>
                    </div>
                    <div className={classes.subLabel}>{cfg('claimDetails.claimNumber')}: {props.claim?.claimNumber}</div>
                    <div className={classes.subLabel1}>{cfg('invoice.plsInputDetails')}</div>

                    <div  className={classes.Mform} ref={ref}>
                        <div className={classes.member_input}>
                            <FieldWrapper>
                                <QnectTextField
                                    field="providerInvoiceNo"
                                    value={providerInvoiceNo}
                                    onChange={event => {
                                        setErrorMessage([]);
                                        setProviderInvoiceNo(event.target.value);
                                    }}
                                    formId={formId}
                                    maxLength={80}
                                />
                            </FieldWrapper>

                            <FieldWrapper>
                                <QnectTextField
                                    field="claimAmount"
                                    value={claimAmount}
                                    onChange={event => {
                                        setErrorMessage([]);
                                        setClaimAmount(event.target.value);
                                    }}
                                    formId={formId}
                                    onInput = {(e) =>{
                                        e.target.value = _formatDecimalAmount(e.target.value);
                                    }}
                                    maxLength={18}
                                />
                            </FieldWrapper>

                            <FieldWrapper>
                                <QnectCheckBox
                                    formId={formId}
                                    field="desktop"
                                    checked={isDesktop}
                                    disabled={false}
                                    onChange={(event) => changeDesktop(event)}
                                />
                                <div className={classes.desktopTooltip}>
                                    <BalloonTip>{cfg('invoice.desktopTooltip')}</BalloonTip>
                                </div>
                            </FieldWrapper>

                            <FieldWrapper>
                                <QnectCheckBox
                                    formId={formId}
                                    field="discountCheckbox"
                                    checked={isDiscount}
                                    disabled={false}
                                    onChange={(event) => changeDiscount(event)}
                                />
                                {isDiscount &&
                                <>
                                    <FieldWrapper>
                                        <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group" value={selectedDiscountBasis} onChange={(event) => changeDiscountBasis(event.target.value)}>
                                            <FormControlLabel value="discountPercentageRadio" control={<Radio />} label="Discount %" />
                                            <FormControlLabel value="discountAmountRadio" control={<Radio />} label="Discount Amount" />
                                        </RadioGroup>
                                    </FieldWrapper>
                                    {selectedDiscountBasis === 'discountPercentageRadio' && 
                                        <FieldWrapper>
                                            <QnectTextField
                                                field="discountPercentage"
                                                value={discountPercentage}
                                                onChange={(event) => {
                                                    setErrorMessage([]);
                                                    validateDiscountLimit(event.target.value);
                                                }}
                                                formId={formId}
                                                onInput = {(e) =>{
                                                    e.target.value = _formatDecimalAmount(e.target.value);
                                                }}
                                                endAdornment={'%'}
                                                maxLength={6}
                                            />
                                        </FieldWrapper>
                                    }
                                    {selectedDiscountBasis === 'discountAmountRadio' &&
                                        <FieldWrapper>
                                            <QnectTextField
                                                field="discountAmount"
                                                value={discountAmount}
                                                onChange={(event) => {
                                                    setErrorMessage([]);
                                                    setDiscountAmount(event.target.value);
                                                }}
                                                formId={formId}
                                                onInput = {(e) =>{
                                                    e.target.value = _formatDecimalAmount(e.target.value);
                                                }}
                                                endAdornment={currency}
                                                maxLength={18}
                                            />
                                        </FieldWrapper>
                                    }
                                </>}
                            </FieldWrapper>

                            <FieldWrapper>
                                <Grid direction='row' container spacing={1}>
                                    <Grid container item sm={9}>
                                        <QnectCheckBox
                                            formId={formId}
                                            field="disbursement"
                                            checked={isDisbursement}
                                            disabled={false}
                                            onChange={(event) => changeDisbursement(event)}
                                        />
                                        <div className={classes.disbursementTooltip}>
                                            <BalloonTip>{cfg('invoice.disbursementTooltip')}</BalloonTip>
                                        </div>
                                    </Grid>
                                    {isDisbursement && <Grid container item sm={3}>
                                        <Button variant="text" endIcon={<AddCircleIcon/>} onClick={handleAddRow}>Add</Button>
                                    </Grid>}
                                </Grid>
  
                                {isDisbursement && disbursements && disbursements.map((item, idx) => (
                                    <FieldWrapper key={idx}>
                                        <Grid direction='row' container spacing={1}>
                                            <Grid container item sm={6}>
                                                <QnectTextField
                                                    formId={formId}
                                                    field="disbursementDesc"
                                                    onBlur={event => handleUpdateDisbursementFields(idx, 'disbursementDesc', event.target.value)}
                                                    value={item.disbursementDesc}
                                                    maxLength={80}
                                                />
                                            </Grid>
                                            <Grid container item sm={4}>
                                                <QnectTextField
                                                    formId={formId}
                                                    field="disbursementAmt"
                                                    onBlur={event => handleUpdateDisbursementFields(idx, 'disbursementAmt', event.target.value)}
                                                    value={item.disbursementAmt}
                                                    onInput = {(e) =>{
                                                        e.target.value = _formatDecimalAmount(e.target.value);
                                                    }}
                                                    label={currency}
                                                    maxLength={18}
                                                />
                                            </Grid>
                                            <Grid container item sm={2}>
                                                <IconButton color="primary" style={{cursor:"pointer", marginRight:11}} onClick={() => handleRemoveRow(idx)}>
                                                    <RemoveCircleIcon/>
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                    </FieldWrapper>
                                ))}
                            </FieldWrapper>

                            <FieldWrapper>
                                <QnectCheckBox
                                    formId={formId}
                                    field="qbeShare"
                                    checked={isQbeShare}
                                    disabled={false}
                                    onChange={(event) => changeQbeShare(event)}
                                />

                                {isQbeShare && 
                                    <FieldWrapper>
                                        <QnectTextField
                                            field="qbeShareRate"
                                            value={qbeShareRate}
                                            onChange={(event) => {
                                                setErrorMessage([]);
                                                validateQbeShareLimit(event.target.value);
                                            }}
                                            formId={formId}
                                            onInput = {(e) =>{
                                                e.target.value = _formatDecimalAmount(e.target.value);
                                            }}
                                            endAdornment={'%'}
                                            maxLength={6}
                                        />
                                    </FieldWrapper>
                                }
                            </FieldWrapper>

                            <FieldWrapper>
                                <QnectButton
                                    field="calculate"
                                    onClick={calculateTotalFee}
                                    disabled={!claimAmount}
                                />
                            </FieldWrapper>

                            <FieldWrapper>
                                <div className={classes.totalFeeRectangle}>
                                    <div style={{float: 'left'}}>
                                        <div className={classes.subLabel} style={{paddingLeft: '10px'}}>{cfg('invoice.totalFee')}</div>
                                    </div>
                                    <div style={{float: 'right'}}>
                                        <div className={classes.subLabel} style={{paddingRight: '10px'}}>{currency} {totalFee}</div>
                                    </div>
                                </div>
                            </FieldWrapper>

                            {props.country !== 'HKG' &&
                            <div>
                                <FieldWrapper>
                                    <QnectTextField
                                        field="gst"
                                        value={gst}
                                        onChange={event => {
                                            setErrorMessage([]);
                                            setGST(event.target.value);
                                        }}
                                        formId={formId}
                                        onInput = {(e) =>{
                                            e.target.value = _formatDecimalAmount(e.target.value);
                                        }}
                                        maxLength={18}
                                    />
                                </FieldWrapper>

                                <FieldWrapper>
                                    <div className={classes.totalFeeRectangle}>
                                        <div style={{float: 'left'}}>
                                            <div className={classes.subLabel} style={{paddingLeft: '10px'}}>{cfg('invoice.totalInvoiceAmount')}</div>
                                        </div>
                                        <div style={{float: 'right'}}>
                                            <div className={classes.subLabel} style={{paddingRight: '10px'}}>{currency} {totalInvoiceAmount}</div>
                                        </div>
                                    </div>
                                </FieldWrapper>
                           </div>
                            }
                        </div>
                        
                        {errorMessage && (
                            <div className={classes.errorMessage}>
                                <QnectError errorTitle={"Error"} errorMessage={errorMessage} />
                            </div>
                        )}
                    </div>
                </div>
                <div className={classes.document_section}>
                    <div className={classes.uploadDocumentTitle}>{cfg('invoice.uploadInvoice')}</div>
                    <div className={classes.Mform} ref={ref}>
                        <UploadDocument attachments={attachments} setAttachments={setAttachments}
                                        identifier={identifier} setIdentifier={setIdentifier}/>
                        <div className={classes.group_button}>
                            <FieldWrapper>
                                <div style={{float: 'left'}}>
                                    <QnectButton
                                        field="backBtn"
                                        onClick={() => history.push("/viewInvoice")}
                                    />
                                </div>
                                <div style={{float: 'right'}}>
                                    <QnectButton
                                        field="submit"
                                        onClick={() => {
                                            calculateTotalFee();
                                            setIsSubmit(true);
                                        }}
                                    />
                                </div>
                            </FieldWrapper>
                        </div>
                    </div>
                </div>
            </div>
            {showSubmitDialog &&
                <SubmitInvoiceDialog invoiceForm={invoiceForm} currency={currency}
                                 onSubmit={(onSubmit) => setShowSubmitDialog(onSubmit)} />
            }
        </Container> 
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        country: _getCountry(state),
        lang: _getLang(state),
        claim: _getClaim(state)
    }
}

const mapDispatchToProps = {
    showSpinner: _showSpinner,
    hideSpinner: _hideSpinner,
    showModal: _showModal,
    hideModal: _hideModal,
    showError: _showError,
    getInvoiceRaterDetails: _getInvoiceRaterDetails,
    submitInvoice: _submitInvoice
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps) (ClaimAmountCalculation));
